<template>
    <v-container class="ma-0 pa-0" fluid>
        <v-row class="ma-0 mb-1 pa-0 text-center">
            <v-spacer/>
            <h1>출하검사 부적합품 내용 조건 기간별 현황표</h1>
            <v-spacer/>
        </v-row>
        <v-row class="ma-0 pa-0" no-gutters>
            <template v-for="(item, i) in gridTitle">
                <v-col :key="i">
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="25">
                        {{gridTitle[i]}}
                    </v-card>
                </v-col>
            </template>
        </v-row>
        <v-row class="ma-0 pa-0" no-gutters v-for="(item, i) in gridData" :key="i">
            <template v-for="(row, j) in item">
                <v-col :key="j">
                    <v-card
                            class="pa-0 ma-0 text-center"
                            outlined
                            tile
                            height="25">
                        {{row}}
                    </v-card>
                </v-col>
            </template>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'GraphDataOG3',
  props: {
    update: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: ''
    },
    DataList: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    gridTitle: [],
    item: [],
    gridData: [],
    graphWidth: 1170,
    graphHeight: 200,
    MarginLeft: 60,
    MarginRight: 60,
    MarginTop: 10,
    MarginBottom: 18,
    ctx: null,
    max: 0
  }),
  methods: {
    getTitle () {
      this.item = []
      for (let i = 0; i < this.DataList.length; i++) {
        this.addItem(this.DataList[i].defectedItem1, this.DataList[i].defectedNumber1)
        this.addItem(this.DataList[i].defectedItem2, this.DataList[i].defectedNumber2)
        this.addItem(this.DataList[i].defectedItem3, this.DataList[i].defectedNumber3)
      }
      this.item.sort(this.customSort)

      const maxCount = 8
      while (this.item.length > maxCount) {
        this.item[maxCount - 1].name = '기타'
        this.item[maxCount - 1].value += this.item[maxCount].value
        this.item.splice(maxCount, 1)
      }
      this.gridTitle = []
      this.gridTitle.push('검사일자')
      this.gridTitle.push('분모(대상수량)')
      this.gridTitle.push('분자(부적합수량)')
      this.gridTitle.push('불량율(ppm)')
      for (let i = 0; i < this.item.length; i++) {
        this.gridTitle.push(this.item[i].name)
      }
    },
    addItem (item, count) {
      if (item === null || item === 'null') return
      if (count === null || count === 'null') return
      if (typeof item === 'undefined') return
      if (typeof count === 'undefined') return
      count = parseInt(count)
      for (let i = 0; i < this.item.length; i++) {
        if (this.item[i].name === item) {
          this.item[i].value += count
          return
        }
      }
      this.item.push({ name: item, value: count })
    },
    customSort (a, b) {
      if (a.value === b.value) {
        return 0
      }
      return a.value < b.value ? 1 : -1
    },
    getData () {
      this.gridData = []
      for (let i = 0; i < this.DataList.length; i++) {
        let item = []
        item.push(this.DataList[i].inspectionDate)
        item.push(this.DataList[i].targetNumber)
        item.push(this.DataList[i].defectedNumber)
        item.push(this.DataList[i].defectedRate)

        for (let j = 0; j < this.item.length; j++) {
          item.push('-')
        }

        this.getCount(this.DataList[i].defectedItem1, this.DataList[i].defectedNumber1, item)
        this.getCount(this.DataList[i].defectedItem2, this.DataList[i].defectedNumber2, item)
        this.getCount(this.DataList[i].defectedItem3, this.DataList[i].defectedNumber3, item)

        this.gridData.push(item)
      }
    },
    getCount (name, count, item) {
      if (item === null || item === 'null') return
      if (count === null || count === 'null') return
      if (typeof item === 'undefined') return
      if (typeof count === 'undefined') return
      let index = this.item.length - 1
      for (let i = 0; i < this.item.length; i++) {
        if (this.item[i].name === name) {
          index = i
          break
        }
      }
      if (item[index + 4] === '-') {
        item[index + 4] = count
      } else {
        item[index + 4] = parseInt(item[index + 4]) + parseInt(count)
      }
    }
  },
  mounted () {
    this.getTitle()
    this.getData()
  },
  created () {
  },
  watch: {
    update () {
      this.getTitle()
      this.getData()
    }
  }

}
</script>

<style scoped>
</style>
